if (!customElements.get('shipping-protection')) {
  customElements.define(
    'shipping-protection',
    class ShippingProtection extends HTMLElement {
      constructor() {
        super();

        this.variantId = parseInt(this.getAttribute('data-variant-id'));
        this.protectionInCart = parseInt(this.getAttribute('data-protection-in-cart')) || 0;
        this.itemsInCart = parseInt(this.getAttribute('data-items-in-cart')) || 0;

        this.declinedValue = (theme.shippingProtection && theme.shippingProtection.declined) || '';
        this.isDeclined = this.declinedValue.length > 0 && this.getAttribute('data-declined') === this.declinedValue;
      }

      get toggle() {
        return this.querySelector('input[type="checkbox"]');
      }

      get attribute() {
        return (theme.shippingProtection && theme.shippingProtection.attribute) || 'Shipping Protection';
      }

      connectedCallback() {
        if (!this.variantId || this.toggle === null) return;

        // When the customer flips the switch on or off.
        this.toggle.addEventListener('change', theme.utils.debounce((event) => {
          event.target.checked ? this.addProtection() : this.removeProtection(true);
        }, 300));

        // The cart only contains the protection product (no real items), so remove it.
        if (this.itemsInCart < 1 && this.protectionInCart > 0) {
          return this.removeProtection(false);
        }

        // The cart has real items but protection is missing and was not declined, so auto-enable it.
        if (this.itemsInCart > 0 && this.protectionInCart < 1 && !this.isDeclined) {
          // Safety valve: if the product can't be added (e.g. unexpectedly unavailable) the section
          // would keep re-rendering and retrying, so cap the automatic attempts per page load.
          window.shippingProtectionAutoAdds = (window.shippingProtectionAutoAdds || 0) + 1;
          if (window.shippingProtectionAutoAdds > 3) return;
          return this.addProtection();
        }
      }

      addProtection() {
        this.enableLoading();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates: {
            [this.variantId]: 1
          },
          attributes: {
            [this.attribute]: ''
          },
          sections: sectionsToBundle
        });

        this.fetchUpdate(body);
      }

      removeProtection(declined) {
        this.enableLoading();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates: {
            [this.variantId]: 0
          },
          attributes: {
            // Remember an explicit decline so we don't re-add it; a lonely-cart cleanup clears it instead.
            [this.attribute]: declined ? this.declinedValue : ''
          },
          sections: sectionsToBundle
        });

        this.fetchUpdate(body);
      }

      fetchUpdate(body) {
        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cart: parsedState });
          })
          .catch((error) => {
            console.error(error);
            // On a network error no re-render happens, so revert the loading state and the toggle
            // so the row doesn't stay stuck/disabled until a page reload.
            this.disableLoading();
            if (this.toggle) this.toggle.checked = this.protectionInCart > 0;
          });
      }

      enableLoading() {
        this.classList.add('pointer-events-none');

        const loader = this.querySelector('.loader');
        if (loader) loader.hidden = false;
      }

      disableLoading() {
        this.classList.remove('pointer-events-none');

        const loader = this.querySelector('.loader');
        if (loader) loader.hidden = true;
      }
    }
  );
}
